exports = module.exports = require("../../node_modules/css-loader/lib/css-base.js")(false);
// imports


// module
exports.push([module.id, ".preview{padding-top:56.25%;position:relative;width:100%}.preview iframe,.preview object{bottom:0;left:0;position:absolute;right:0;top:0;height:100%}", ""]);

// exports
